@for (modelPair of modelPairs; track modelPair) {
  <div class="row pad-top-10">
    @for (model of modelPair; track model) {
      <div class="column twelve md-six policy pad-horizontal-20">
        <span class="double-icon float-left pad-right-10">
          <i class="icon" [ngClass]="model.policy.iconType"></i>
        </span>
        <div class="policy-info">
          <div>Policy {{ model.policy | prettyPolicyNum }}</div>
          <div>{{ model.policy.policyRisks | risk | arrayToList }}</div>
        </div>
      </div>
    }
  </div>
}
